import React from "react";

import { useSelector, useDispatch } from "react-redux";

import { MenuButton } from "./MenuButton";
import { logOutMiddleware } from "../../redux/middlewares/AuthenticateMiddleware";

import Call from "./Call";
import { ABOUT_PAGE_URL } from "../../constants/publicUrls";

export default function SideMenu(props) {
  const dispatch = useDispatch();
  const authenticateState = useSelector((state) => state.authenticate);

  const userCountry = authenticateState.user.country.code;

  return (
    <div className={`flex-column px-2 py-3`}>
      {/* <MenuButton
        icon="pi pi-home"
        label="Home"
        to="/"
        onMenuClick={props.hideMenu}
      /> */}

      <MenuButton
        icon="pi pi-user"
        label="Profile"
        to={`/profile/${authenticateState.user_id}`}
        onMenuClick={props.hideMenu}
      />

      <MenuButton
        icon="pi pi-search"
        label="Search"
        to="/search"
        onMenuClick={props.hideMenu}
      />

      <MenuButton
        icon="pi pi-send"
        label="Messages"
        to="/chat"
        onMenuClick={props.hideMenu}
      />

      <MenuButton
        icon="pi pi-home"
        label="About"
        onMenuClick={() => {
          window.open(ABOUT_PAGE_URL, "_self");
        }}
      />

      <MenuButton
        icon="pi pi-sign-out"
        label="Logout"
        onMenuClick={() => {
          dispatch(logOutMiddleware());
          props.onMenuClick();
        }}
      />

      {userCountry === "SN" ? (
        <Call
          country={"INFoCAT Senegal"}
          docTitle={"APPEL INFoCAT à l'INNOVATION (Détails)"}
          docLink={
            "https://docs.google.com/document/d/1H7K95rWSo1tOpzB0ujr0dIQMGw902zguT8nOq39pfeI/edit?usp=sharing"
          }
          formTitle={"POSTULEZ MAINTENANT Pour l'appel"}
          formLink={
            "https://www.cognitoforms.com/Justis2/APPELOUVERTPOURLESINNOVATIONSENMATI%C3%88REDETECHNOLOGIESAGRICOLESPROPRES"
          }
        />
      ) : userCountry === "CI" ? (
        <Call
          country={"INFoCAT Côte d'Ivoire"}
          docTitle={"APPEL INFoCAT à l'INNOVATION (Détails)"}
          docLink={
            "https://docs.google.com/document/d/1UTDqCdTyRParVCcBhs4kreY2sKjueFDnvzPI9mRf6WQ/edit?usp=sharing"
          }
          formTitle={"POSTULEZ MAINTENANT Pour l'appel"}
          formLink={
            "https://www.cognitoforms.com/Justis2/APPELOUVERTPOURLESINNOVATIONSENMATI%C3%88REDETECHNOLOGIESAGRICOLESPROPRES"
          }
        />
      ) : null}

      {/* This is the a template for public announcements to all countries  */}
      {/* <a
        href="https://www.google.com"
        target="_blank"
        rel="noreferrer noopener"
        className="text-white no-underline bg-primary-500 p-1 border-round mt-5"
      >
        <div className="flex gap-2 align-items-center px-2">
          <FaRegNewspaper size={20} />
          <p className="font-bold text-center text-sm">
            <Translate>Public Announcement</Translate>
          </p>
        </div>
      </a> */}
    </div>
  );
}
